$(document).on('click', '.add-to-cart-btn', function() {
  // Get the variant ID from the clicked button's data-id attribute
  var variantID = $(this).attr('data-id');

  // Check if variant ID exists
  if (!variantID) {
    console.error("Variant ID not found!");
    return;
  }

  // Send the AJAX request to add the product to the cart
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantID // Variant ID
    },
    dataType: 'json',
    success: function(data) {
      // Refresh cart after adding the item
      cartreffffresh();
    },
    error: function(xhr, status, error) {
      // Log the error for debugging
      console.error("Error adding product to cart:", error);
      alert("There was an error adding the product to the cart.");
      cartreffffresh();
    }
  });
});

function cartreffffresh(){
  // Fetch the updated cart sections
  fetch(window.Shopify.routes.root + 'cart?sections=cart-drawer,cart-icon-bubble', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  .then(response => response.json())
  .then(data => {
    // Update the cart drawer with new HTML content
    const DrawerUpdate = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer').outerHTML;
    const BubbleUpdate = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').outerHTML;

    // Check if cart drawer exists and update it
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) { 
      cartDrawer.outerHTML = DrawerUpdate; // Replace the whole cart drawer element
      const updatedDrawer = document.querySelector('cart-drawer'); // Re-fetch the updated element
      updatedDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }

    // Check if cart icon bubble exists and update it
    const cartIconBubble = document.querySelector('#cart-icon-bubble');
    if (cartIconBubble) {
      cartIconBubble.innerHTML = BubbleUpdate; // Update the inner content of the cart icon bubble
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
// $(document).ready(function () {
//   $('.video-catg').on('click', function () {
//     // Find the closest video to the clicked play button
//     let $video = $(this).closest('.video-category-block').find('.video-catg');
//     let video = $video[0]; // Get the DOM element of the video

//     if (!video) {
//       console.error("Video element not found!");
//       return;
//     }

//     let dataPoster = $video.data('poster'); // Get the data-poster attribute

//     // Pause all other videos and reset their posters
//     $('.video-catg').each(function () {
//       if (this !== video) {
//         this.pause(); // Pause other videos
//         $(this).closest('.video-category-block').find('.play-btn').html(`<svg class="play-btn-svg" xmlns="http://www.w3.org/2000/svg" width="105" height="105" viewBox="0 0 105 105" fill="none">  <circle cx="52.5" cy="52.5" r="52.5" fill="#D9D9D9"/>  <path d="M45 64.0489V40.1259C45 38.4551 46.9273 37.5209 48.2389 38.5559L63.9384 50.9446C64.9755 51.7629 64.9482 53.3442 63.8836 54.1264L48.1842 65.6606C46.8633 66.631 45 65.6879 45 64.0489Z" fill="white"/></svg>`); 
//         $(this).attr('poster', $(this).data('poster')); // Reset poster for other videos
//       }
//     });

//     // Toggle play/pause for the current video
//     if (video.paused) {
//       video.play(); // Play the current video
     
//       $video.attr('poster', ''); // Remove the poster for the current video
//     } else {
//       video.pause(); // Pause the current video
//       $(this).html(`<svg class="play-btn-svg" xmlns="http://www.w3.org/2000/svg" width="105" height="105" viewBox="0 0 105 105" fill="none">  <circle cx="52.5" cy="52.5" r="52.5" fill="#D9D9D9"/>  <path d="M45 64.0489V40.1259C45 38.4551 46.9273 37.5209 48.2389 38.5559L63.9384 50.9446C64.9755 51.7629 64.9482 53.3442 63.8836 54.1264L48.1842 65.6606C46.8633 66.631 45 65.6879 45 64.0489Z" fill="white"/></svg>`); // Reset button text // Change button text to "Play"
//       $video.attr('poster', dataPoster); // Restore the poster for the current video
//     }
//   });
// });


$(document).ready(function () {
  function initializeSlider() {
    if ($(window).width() <= 767) {
      if (!$('.icon-with-text').hasClass('slick-initialized')) {
        $('.icon-with-text').slick({
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
           responsive: [
    {
      breakpoint: 425,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
             ]
        });
      }
    } else {
      if ($('.icon-with-text').hasClass('slick-initialized')) {
        $('.icon-with-text').slick('unslick');
      }
    }
  }

  initializeSlider();

  $(window).on('resize', function () {
    initializeSlider();
  });
});


    $(document).ready(function () {
      $('.product-form__submit').on('click', function (event) {
        event.preventDefault(); // Prevent default form submission

        // Get the textarea value and variant ID
        var customMessage = $('.form-control').val();
        var variantId = $('.product-variant-id').val();

        // Prepare the data for the AJAX request
        var requestData = {
          id: variantId, // Variant ID
          properties: {
            Message: customMessage // Custom field
          }
        };

        // Send the AJAX request to add the product to the cart
        $.ajax({
          type: 'POST',
          url: '/cart/add.js', // Shopify endpoint for adding items to the cart
          data: requestData,
          dataType: 'json',
          success: function (response) {
            $.ajax({
            type : "GET",
            url : "/cart.js",
            dataType: 'json',
            success: function(cartItem){
            let updatedQuantity = cartItem.item_count || 0;
            $('.header__count-bubble span').text(updatedQuantity);
            $('cart-drawer').load(window.location.href + ' #CartDrawer');
            $('cart-drawer').removeClass('is-empty');
            $('cart-drawer').addClass('active');
            }
            });
          },
          error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
            alert('Failed to add product to cart. Please try again.');
          }
        });
      });
    });
 
